// assets
import Arrow from "assets/icons/forward.svg";
import Check2 from "assets/icons/pop-check.svg";
import Back from "assets/svg/back-arrow.svg";
import Load from "assets/svg/other/loading2.svg";
import Header from "components/dashHeader";
// components
import Sidemenu from "components/sidemenu";
//css
import "pages/styles/dashboard/P2P.css";
import React, { Component } from "react";
import { Link, useHistory } from "react-router-dom";
import { useStore } from "store";
import styled from "styled-components";
//import { logger } from "util/logger";
import { get, post } from "util/axiosLib";
//import Cancel from "assets/icons/sm-x.svg";
import { logger } from "util/logger";
import { getParameterByName } from "util/utils";

export default function P2PTradeView(props) {
  const { store, dispatch, localSocket } = useStore();
  const history = useHistory();

  return (
    <P2PView
      {...props}
      store={store}
      dispatch={dispatch}
      localSocket={localSocket}
      history={history}
    />
  );
}

class P2PView extends Component {
  state = {
    popUpClicked: false,
    confirmationClicked: false,
    tradeData: [],
    tradeOption: [],
    listingKey: "listing",
  };

  handleCancel = (event) => {
    event.preventDefault();

    this.setState({ confirmationClicked: true });
  };

  handleRemove = (event) => {
    event.preventDefault();

    this.setState({ popUpClicked: false });
    this.setState({ popUpRemove: true });
    // const element = document.getElementById("rem-box");
    // element.classList.toggle("rem-box-off");
    setTimeout(function () {
      document.querySelector("#rem-box").style.display = "none";
    }, 1000);
  };

  loadTrade = async () => {
    const localSocket = this.props.localSocket;
    try {
      const token = this.props?.store?.token;

      const tradeUrl = window.location.pathname;
      const tradeId = tradeUrl.substr(19);

      const listingType = getParameterByName("type");

      const listingKey = listingType === "flexi" ? `flexiListing` : "listing";

      const headers = {
        authorization: `${token}`,
        "Content-Type": "application/json",
      };
      if (!tradeId) {
        return this.props.history.push("/dashboard/p2p");
      }
      const getTradeReq = await get(
        `${process.env.REACT_APP_API_ENDPOINT}/p2p/${listingKey}/${tradeId}`,
        headers
      );

      this.setState({
        tradeData: getTradeReq?.data?.data,
        tradeOption: getTradeReq?.data?.data?.tradeOption,
        tradeCost: getTradeReq?.data?.data?.totalCost?.$numberDecimal,
        tradeValue: getTradeReq?.data?.data?.currentVolume?.$numberDecimal,
        tradeId,
        isLoaded: true,
        listingKey,
      });

      logger(this.state.tradeData);

      return Promise.resolve(true);
    } catch (err) {
      const errData = err.response;
      if (errData?.status === 403 || errData?.status === 401) {
        const errmsg = document.getElementById("error-info2");
        errmsg?.classList?.add("err-auth-on");
        this.setState({ incorrectError: "Token expired, please login again." });
        localSocket && localSocket.emit("LOGOUT");
      }
    }
  };

  handleConfirmed = async (event) => {
    const localSocket = this.props.localSocket;
    event && event.preventDefault();
    try {
      const token = localStorage.getItem("tokenset");
      const tradeId = this.state.tradeId;

      const headers = {
        authorization: `${token}`,
        "Content-Type": "application/json",
      };
      const cancelDetails = {
        volume: this.state?.tradeData?.currentVolume?.$numberDecimal,
        sourceUnit: this.state?.tradeData?.sourceUnit,
        destinationUnit: this.state?.tradeData?.destinationUnit,
        totalCost: this.state.tradeData?.totalCost?.$numberDecimal,
      };
      const cancelReq = await post(
        `${process.env.REACT_APP_API_ENDPOINT}/p2p/${this.state.listingKey}/${tradeId}/cancel`,
        cancelDetails,
        headers
      );

      this.setState({
        successMessage: "Ad Cancelled",
      });
      const errmsg = document.getElementById("succ-info");
      errmsg.classList.add("error-info-on");

      setTimeout(() => {
        this.props.history.push("/dashboard/p2p");
      }, 1500);

      logger(cancelReq);

      return Promise.resolve(true);
    } catch (err) {
      logger("update ERROR::: ", err);
      if (err.isAxiosError) {
        const errData = err.response;

        this.setState({
          errorMessage: Object.values(errData.data.error),
        });
        const errmsg = document.getElementById("error-info");
        errmsg.classList.add("error-info-on");

        if (errData?.status === 403 || errData?.status === 401) {
          const errmsg = document.getElementById("error-info2");
          errmsg.classList.add("err-auth-on");
          this.setState({
            incorrectError: "Token expired, please login again.",
          });
          localSocket && localSocket.emit("LOGOUT");
        }
      } else {
        this.setState({ otherError: "Something went wrong" });
      }
    }
  };

  componentDidMount() {
    this.loadTrade();
  }

  render() {
    const currentPage = "P2P";
    const { tradeData } = this.state;

    return (
      <StyledView>
        <Sidemenu currentPage={currentPage} />
        <Header />

        {this.state.popUpClicked ? (
          <div id="rem-box">
            <div className="overlay animate__animated animate__fadeIn "></div>
            <section className="popup">
              <div className="popup-box animate__animated animate__slideInDown">
                <div className="popup-img">
                  <img
                    className=" animate__animated animate__slow animate__jackInTheBox animate__delay-.5s"
                    src={Check2}
                    alt=""
                  />
                </div>
                <h2 className="uppercase">
                  {this.state.tradeValue +
                    " " +
                    this.state.tradeData.sourceUnit}
                </h2>
                <p className="popup-success">Purchased Successfully!</p>
                <p onClick={this.handleRemove} className="popup-close">
                  Close
                </p>
                {/* {document.querySelector('#rem-box').style.display = "block"} */}
              </div>
            </section>
          </div>
        ) : null}
        {this.state.popUpRemove === true && (
          <div id="rem-box">
            <div className="overlay animate__animated animate__fadeOut "></div>
            <section className="popup">
              <div className="popup-box animate__animated animate__backOutUp">
                <div className="popup-img">
                  <img
                    className=" animate__animated animate__slow animate__jackInTheBox animate__delay-.5s"
                    src={Check2}
                    alt=""
                  />
                </div>
                <h2 className="uppercase">
                  {this.state.tradeValue +
                    " " +
                    this.state.tradeData.sourceUnit}
                </h2>
                <p className="popup-success">Purchased Successfully!</p>
                <p onClick={this.handleRemove} className="popup-close">
                  Close
                </p>
              </div>
            </section>
          </div>
        )}

        {this.state.confirmationClicked ? (
          <div>
            <div className="overlay animate__animated animate__fadeIn "></div>
            <section className="summaryclicked">
              <div className="summaryclicked-box animate__animated animate__slideInUp">
                <div className="sc-top2">
                  <h2>Confirm Cancellation</h2>
                  {/* <img
                    onClick={() => this.setState({ confirmationClicked: false })}
                    src={Cancel}
                    alt="close"
                  /> */}
                </div>

                <p className="can-info bold ">
                  Are you sure you want to cancel this Ad listing?
                </p>

                {/* <button
                  onClick={this.handleSummary}
                  className="summaryclicked-btn"
                >
                  Submit
                </button> */}
                <div className="sc-bottom">
                  <button
                    className="sm-btn-plain right-m0"
                    onClick={() =>
                      this.setState({ confirmationClicked: false })
                    }>
                    No
                  </button>
                  <button onClick={this.handleConfirmed} className="sm-btn-red">
                    Yes, Cancel
                  </button>
                </div>

                <div
                  id="succ-info"
                  className="succ-info animate__animated animate__fadeIn">
                  <p>{this.state.successMessage}</p>
                </div>
                <div
                  id="error-info"
                  className="error-info animate__animated animate__fadeIn">
                  <p>{this.state.errorMessage}</p>
                </div>
              </div>
            </section>
          </div>
        ) : null}

        <section className="p2p">
          <div className="p2p-container">
            <div className="p2p-content">
              <Link to="/dashboard/p2p">
                <img src={Back} className="w-backarrow" alt="back" />
              </Link>
              <h1> View </h1>
              <div className="p2p-nav">
                <Link to="/dashboard/p2p" className="right-e">
                  <p className="ash"> P2P </p>{" "}
                </Link>
                <img className="right-e" src={Arrow} alt="" />
                <p>
                  <span className="bold"> View</span>
                </p>
              </div>
              <div
                id="error-info2"
                className="err-auth zindex animate__animated animate__slideInDown">
                <p>
                  <strong>{this.state.incorrectError}</strong>
                </p>
              </div>
              {this.state.isLoaded && this.state.tradeData ? (
                <div className="p2p-boxes">
                  <div className="p2p-right-box2">
                    <p className="ad-info-title2 green bold">Ad Listing Info</p>
                    <div className="p2p-ad-info">
                      <p>Date & Time</p>
                      <p className="bold uppercase">
                        {this.state?.tradeData?.createdAt.substr(0, 10)}
                        {/* <br /> */}
                        {this.state.tradeData?.createdAt?.substr(11, 8)}
                      </p>
                    </div>
                    <div className="p2p-ad-info">
                      <p>Coin</p>
                      <p className="bold uppercase">
                        {this.state?.tradeData?.sourceUnit}
                      </p>
                    </div>
                    <div className="p2p-ad-info">
                      <p>Quantity</p>
                      <p className="bold uppercase">
                        {Number(
                          this.state.tradeData?.volume.$numberDecimal
                        ).toLocaleString()}
                      </p>
                    </div>
                    <div className="p2p-ad-info">
                      <p>Current Volume</p>
                      <p className="bold uppercase">
                        {Number(this.state.tradeValue).toLocaleString()}
                      </p>
                    </div>

                    <div className="p2p-ad-info">
                      <p>Price</p>
                      <p className="bold">
                        {Number(this.state.tradeCost).toLocaleString()}
                        <span className="green uppercase">
                          {" "}
                          {String(
                            this.state.tradeData.destinationUnit
                          ).toUpperCase()}
                        </span>
                      </p>
                    </div>
                    {this.state.tradeData.adsStatus === "open" && (
                      <div className="p2p-ad-info">
                        <p>Status</p>
                        <p className="bold">
                          <span className="green uppercase"> open </span>
                        </p>
                      </div>
                    )}
                    {this.state.tradeData.adsStatus === "closed" && (
                      <div className="p2p-ad-info">
                        <p>Status</p>
                        <p className="bold">
                          <span className=" uppercase"> closed </span>
                        </p>
                      </div>
                    )}
                    {this.state.tradeData.adsStatus === "cancelled" && (
                      <div className="p2p-ad-info">
                        <p>Status</p>
                        <p className="bold">
                          <span className="red uppercase"> cancelled </span>
                        </p>
                      </div>
                    )}

                    {this.state.tradeOption !== undefined && (
                      <div className="p2p-ad-info">
                        <p>Accepts Partial Filling</p>
                        <p className="bold">Yes</p>
                      </div>
                    )}
                    {this.state.tradeOption !== undefined &&
                      this.state.tradeOption.unitCost !== undefined && (
                        <div className="p2p-ad-info">
                          <p>Unit Cost (Rate)</p>
                          <p className="bold">
                            {this.state.tradeOption.unitCost}
                            <span className="green uppercase">
                              {" "}
                              {this.state.tradeData.sourceUnit}
                            </span>
                          </p>
                        </div>
                      )}
                    {this.state.tradeOption !== undefined &&
                      this.state.tradeOption.minimumFilling !== undefined && (
                        <div className="p2p-ad-info">
                          <p>Minimum Filling</p>
                          <p className="bold">
                            {this.state.tradeOption.minimumFilling}
                          </p>
                        </div>
                      )}
                    {this.state.tradeOption !== undefined &&
                      this.state.tradeOption.maximumFilling !== undefined && (
                        <div className="p2p-ad-info">
                          <p>Maximum Filling</p>
                          <p className="bold">
                            {this.state.tradeOption.maximumFilling}
                          </p>
                        </div>
                      )}

                    <div className="p2p-ad-info">
                      <p>Location</p>
                      <p className="bold">{this.state.tradeData.country}</p>
                    </div>

                    {tradeData.userId === this.props.store?.userData?.userId &&
                      tradeData.adsStatus === "open" && (
                        <button
                          className="p2p-cancel"
                          type="submit"
                          onClick={this.handleCancel}>
                          Cancel listing
                        </button>
                      )}
                    {tradeData.userId !== this.props.store?.userData?.userId &&
                      tradeData.adsStatus === "open" &&
                      tradeData.adsType === "selling" && (
                        <button
                          className="p2p-single__action buy"
                          type="submit"
                          onClick={() =>
                            this.props.history.push(
                              "/dashboard/p2pbuy/" + tradeData._id
                            )
                          }>
                          Buy listing
                        </button>
                      )}
                    {tradeData.userId !== this.props.store?.userData?.userId &&
                      tradeData.adsStatus === "open" &&
                      tradeData.adsType === "buying" && (
                        <button
                          className="p2p-single__action sell"
                          type="submit"
                          onClick={() =>
                            this.props.history.push(
                              "/dashboard/p2psell/" + tradeData._id
                            )
                          }>
                          Sell to listing
                        </button>
                      )}
                    {tradeData.userId === this.props.store?.userData?.userId &&
                      tradeData.adsStatus !== "open" && (
                        <button
                          className="p2p-single__action status"
                          type="submit">
                          {String(tradeData?.adsStatus).toUpperCase()}
                        </button>
                      )}
                  </div>
                </div>
              ) : (
                <div className="loading-a" id="load">
                  <img src={Load} alt="loading" />
                </div>
              )}
            </div>
          </div>
        </section>
      </StyledView>
    );
  }
}

var StyledView = styled.div`
  .p2p-single__action {
    /* background: #ed2e7e; */
    background: green;
    border-radius: 40px;
    width: 315px;
    height: 64px;
    color: #fff;
    margin: 3.5em auto;
    outline: none;
    border: 0;
    transition: 0.1s ease-in;
    &.status {
      background: #ed2e7e;
    }
  }
`;
